import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  visible: boolean = false;
  constructor() { }

  ngOnInit() {
  }

  wechatClick() {
    this.visible = !this.visible;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts